var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"kafpos-form-success"},[_c(_setup.VueFeedback,{attrs:{"type":"success"},scopedSlots:_vm._u([{key:"feedback-title",fn:function(){return [_vm._v("Köszönjük a kitöltést, az adatok feldolgozását megkezdtük!")]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }